export class MaterialEstimate {
    cost: any;
    unitOfPropertyDetails: string;
    unitOfPropertyDescription: any;
    quantity: number;
    unitCosts: string;
    totalCosts: number;

    constructor() {
        this.unitCosts = null;
        this.totalCosts = null;
    }
}